module.exports = __webpack_public_path__ + "static/cvwo-logo-2d70501ab01577b42a3c57ec711ac272.png";